import { render } from "./LegalModal.vue?vue&type=template&id=7f3954ec&scoped=true"
import script from "./LegalModal.vue?vue&type=script&lang=js"
export * from "./LegalModal.vue?vue&type=script&lang=js"

import "./LegalModal.vue?vue&type=style&index=0&id=7f3954ec&scoped=true&lang=css"

import exportComponent from "/usr/frontend/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f3954ec"]])

export default __exports__